export const TYPES = {
    INTEREST: 'interest',
    PRINCIPAL: 'principal',
}
export const TYPE_TX = {
    [TYPES.INTEREST]: '等额本息',
    [TYPES.PRINCIPAL]: '等额本金'
}
export const TABS = [
    {
        key: TYPES.INTEREST,
        name: '等额本息',
    },
    {
        key: TYPES.PRINCIPAL,
        name: '等额本金'
    }
]